import React from "react";
import myAppdes from "../../assests/projects_img/mobile_app.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css"; // Ensure you import Swiper CSS
import { mobile_socialMedia_App } from "../../data/dummyData";

function EducationMobileApps() {
  return (
    <div className="edu_category">
      <div className="edu_category_title">
        <h4>Education📚</h4>
        <h4>{mobile_socialMedia_App.length}Apps</h4>
      </div>

      <Swiper
        watchSlidesProgress={true}
        slidesPerView={3} // Control the number of items in one row
        spaceBetween={10} // Add space between slides
        className="mySwiper"
      >
        {mobile_socialMedia_App.map((socal_meadia_mobile_app, index) => (
          <SwiperSlide className="edu_app_container" key={index}>
            <a
              href="www.google.com" // Add the link for each app
              target="_blank" // Open in a new tab
              rel="noopener noreferrer" // Security feature for external links
            >
              <img src={myAppdes} alt="" />
              <h5>{socal_meadia_mobile_app.title}</h5>
              <small>{socal_meadia_mobile_app.date}</small>
            </a>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default EducationMobileApps;
